// 🕯️ Launch Candle / 📈 Carry badge — the candle-lifecycle signal.
export const CandleBadge = ({ candle, size = "sm" }) => {
  if (!candle || (candle.stage !== "launch" && candle.stage !== "carry")) return null;
  const launch = candle.stage === "launch";
  const cls = size === "sm" ? "text-[10px] px-1.5 py-0.5" : "text-xs px-2 py-1";
  const style = launch
    ? { background: "#F0C00022", border: "1px solid #F0C000", color: "#F0C000" }
    : { background: "#4ADE8018", border: "1px solid #4ADE8066", color: "#4ADE80" };
  const title = launch
    ? `Launch Candle — h6≈h24 (${candle.h24}%): the token's whole life is one candle since launch.${candle.freshMint ? " Fresh mint (<30m old)." : ""}`
    : `Carry — 24h ${candle.h24}% & 6h ${candle.h6}% diverged and it's still rising (1h ${candle.h1}%): survived the first candle, still climbing.`;
  return (
    <span
      data-testid={`candle-badge-${candle.stage}`}
      title={title}
      className={`font-mono font-bold tracking-wide inline-flex items-center gap-1 whitespace-nowrap ${cls} ${launch && candle.freshMint ? "animate-pulse" : ""}`}
      style={style}
    >
      {launch ? "🕯️" : "📈"} {launch ? (candle.freshMint ? "FRESH CANDLE" : "LAUNCH CANDLE") : "CARRY"}
    </span>
  );
};
